import http from "../_http_v2";

const user = {
  //default
  list: (m) => { return http.post(`console/management/user/list`, m); },
  detail: (m) => { return http.get(`console/management/user/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/management/user`, m); },
  update: (m) => { return http.put(`console/management/user`, m); },
  delete: (m) => { return http.delete(`console/management/user/${m.id}`); }
}

export default user